export var getWordCount = function getWordCount(editorState) {
  if (!editorState) return 0;
  var rootNode = JSON.parse(editorState).root;
  var allParagraphNodes = rootNode.children;
  return allParagraphNodes.reduce(function (acc, paragraphNode) {
    return acc + paragraphNode.children.reduce(function (textNodeAcc, textNode) {
      return textNodeAcc + textNode.text.split(' ').filter(function (word) {
        return word.replace(/ /g, '');
      }).length;
    }, 0);
  }, 0);
};
export var getCharCount = function getCharCount(editorState) {
  if (!editorState) return 0;
  var rootNode = JSON.parse(editorState).root;
  var allParagraphNodes = rootNode.children;
  return allParagraphNodes.reduce(function (acc, paragraphNode) {
    return acc + paragraphNode.children.reduce(function (textNodeAcc, textNode) {
      return textNodeAcc + textNode.text.length;
    }, 0);
  }, 0);
};
export var getCombinedStringifiedEditorState = function getCombinedStringifiedEditorState(editorStates) {
  if (!editorStates || editorStates.length === 0) return null;
  var combinedEditorState = {
    root: {
      children: editorStates.filter(function (state) {
        return state;
      }).map(function (editorState) {
        return JSON.parse(editorState).root.children;
      }).reduce(function (acc, child) {
        return acc.concat(child);
      }, []),
      direction: 'ltr',
      format: '',
      indent: 0,
      type: 'root',
      version: 1
    }
  };
  return JSON.stringify(combinedEditorState);
};